import EventBus from './event-bus'
import Events from './events'

/**
 * Mounts the global event bus to Vue.$eventbus
 *
 * @export Function The plugin.
 * @returns The plugin.
 */
export default function plugin() {

    return function install(Vue) {

        Object.defineProperty(Vue.prototype, '$eventbus', {
            get() {
                return EventBus
            },
        })

        Object.defineProperty(Vue.prototype, '$appevents', {
            get() {
                return Events
            },
        })
    }
}
